import React, { Component } from 'react';

import withRenderUtils from '../hoc/PreferenceRenderUtil';
import Tab from './Tab';

class PreferenceTabWrapper extends Component {
    constructor (props) {
        super(props);
    }

    render () {

        const {
            activeTab,
            assets,
            channels,
            stateUtils,
            edits,
            handleChange,
            preference,
            renderUtils,
            peerStatus
        } = this.props;

        let sharedProps = {
            assets: assets,
            channels: channels,
            activeTab: activeTab,
            renderUtils: renderUtils,
            handleChange: handleChange,
            preference: preference,
            peerStatus: peerStatus,

            // PreferenceStateUtil HOC
            edits: edits,
            stateUtils: stateUtils,
            settings: stateUtils.reducePreference(activeTab, preference)
        };

        const { name, description } = preference[activeTab];

        return (<div id="tab">
            <header>
                <h2>{name}</h2>
                {description ? <em>{description}</em> : null}
            </header>
            <hr/>
            <Tab {...sharedProps}/>
        </div>);
    }
}

PreferenceTabWrapper.propTypes = {};
var WrapperWithRenderUtils = withRenderUtils(PreferenceTabWrapper);
export default WrapperWithRenderUtils;
